import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    check: {
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    div: {
        display: 'inline-block',
        padding: theme.spacing(1),
        verticalAlign: 'middle',
    },
    icon: {
        verticalAlign: 'middle',
    },
    grab: {
        backgroundColor: theme.palette.grey['300'],
        cursor: 'grab',
    },
    list: {
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        userSelect: 'none',
    },
    resetButton: {
        position: 'fixed',
        right: '8px',
        bottom: '76px',
        zIndex: '1',
    },
}));
